<template>
    <igc-frame class="ig-index">
        <igc-tabs
            class="ig-background--tabs"
            :class="{ 'ig--hidden': translate }"
            :tabs="labels"
            :active="activeTab"
            @switch-tab="switchTab"></igc-tabs>
        <igc-subtab
            class="ig--subtab"
            v-if="activeTabInfo.label && activeTabInfo.label.length > 0"
            v-show="activeTabInfo.label.length > 1"
            :class="{ 'ig--hidden': translate }"
            :tab="activeTabInfo"
            :active="activeSubTab"
            @switch-tab="switchSubTab"></igc-subtab>
        <igc-label class="ig--label"
            v-if="showLabelInfo"
            :class="{ 'ig--offset': translate, 'ig--height': spread }"
            :label="activeSubTab"
            :tab.sync="active"
            @touchstart.native="touchstartEvent"
            @touchend.native="touchendEvent"></igc-label>
        <sui-scroll class="ig--scroll"
            v-else
            @reachEnd="getV4List">
            <igc-ad class="ig--item"
                v-if="this.activeTabInfo.ad"
                :id="this.activeTabInfo.ad"></igc-ad>
            <igc-notice class="ig--item"
                v-if="this.activeTabInfo.notice"
                :notice="this.activeTabInfo.notice"></igc-notice>
            <igc-item-banner class="ig--item"
                v-if="activeSubTabInfo && activeSubTabInfo.url"
                :url="activeSubTabInfo.url"
                :id="activeSubTabInfo.id"></igc-item-banner>
            <template v-for="item in V4List">
                <igc-v4-video class="ig--item"
                    v-if="item.iInfoType == 2"
                    :key="item.works_id"
                    :item="item"></igc-v4-video>
                <igc-v4-news class="ig--item"
                    v-if="item.iInfoType == 1"
                    :key="item.works_id"
                    :item="item"></igc-v4-news>
            </template>
            <sui-load
                :color="mColor(3)"
                :more="more"></sui-load>
        </sui-scroll>
        <igc-ball v-if="ballOn.on" :ball="ballOn"></igc-ball>
    </igc-frame>
</template>

<script>
import { requestV4MixedList } from 'scripts/request'
import { reportPerformanceData } from 'scripts/requests/report'

import mCore from 'scripts/mixins/core'

import IgcFrame from 'components/frame/frame.vue'
import IgcTabs from 'components/tabs/tabs.vue'
import IgcSubtab from '../../components/subtab/subtab.vue'
import IgcV4News from '../../components/v4-news/v4-news.vue'
import IgcV4Video from '../../components/v4-video/v4-video.vue'
import IgcItemBanner from '../../components/item-banner/item-banner.vue'
import IgcLabel from '../../components/label/label.vue'
import IgcAd from '../../components/ad/ad.vue'
import IgcNotice from '../../components/notice/notice.vue'
import igcBall from '../../components/ball/ball.vue'

const { config } = window

export default {
    name: 'ig-index',

    mixins: [mCore],

    components: {
        IgcFrame,
        IgcTabs,
        IgcSubtab,
        IgcAd,
        IgcNotice,
        IgcItemBanner,
        IgcV4News,
        IgcV4Video,
        IgcLabel,
        igcBall
    },

    data() {
        const labels = this.$store.state.global.config.navigators.index.label

        /* #region 将导航转为 map 结构 */
        const labelMap = {}
        labels.forEach(item => {
            if (item.label && item.label.length > 0) {
                item.labelMap = {}
                item.label.forEach(sub => {
                    item.labelMap[sub.id] = sub
                })
            }
            labelMap[item.id] = item
        })
        /* #endregion */

        let activeTab = this.$route.query.tab
        let activeSubTab = this.$route.query.subtab

        // query 中没有正确的一级导航，则取第一个
        if (!activeTab || !labelMap[activeTab]) {
            activeTab = labels[0].id
        }

        // 有二级导航
        if (labelMap[activeTab].label && labelMap[activeTab].label.length > 0) {

            // query 中没有正确的二级导航，则取第一个
            if (!activeSubTab || !labelMap[activeTab].labelMap[activeSubTab]) {
                activeSubTab = labelMap[activeTab].label[0].id
            }

        } else {
            activeSubTab = ''
        }

        return {
            labels, // 导航数据
            labelMap, // 导航数据（map）
            activeTab, // 当前激活的一级 tab
            activeSubTab, // 当前激活的二级 tab
            active: this.$route.query.active ? this.$route.query.active : 0, // 知识点选中 tab
            V4List: [], // V4 列表
            num: 8,
            busy: false,
            more: true,
            originX: 0, // 触摸开始 X 坐标
            originY: 0, // 触摸开始 Y 坐标
            originTime: 0, // 触摸开始时间戳
            translate: false, // 位移
            spread: false, // 高度展开
            timer: 0, // 高度变换定时器,
            ballOn: {},
        }
    },

    watch: {
        'activeTab': {
            handler(nv) {

                // 如果有子导航，切换父导航时不触发，防止调用两遍接口
                if (this.activeTabInfo.label.length > 0) {
                    return
                }

                this.busy = false
                this.more = true
                this.V4List = []
                this.active = 0
                if (!this.showLabelInfo) {
                    this.getV4List()
                }
            }
        },
        
        'activeSubTab': {
            handler(nv) {
                if (!nv) {
                    return
                }
                this.busy = false
                this.more = true
                this.V4List = []
                this.active = 0
                if (!this.showLabelInfo) {
                    this.getV4List()
                }
            }
        },

        'active': {
            handler(nv) {
                this.$router.replace({
                    query: Object.assign({}, this.$route.query, {
                        active: nv
                    })
                })
            }
        }
    },

    computed: {
        activeTabInfo() {
            return this.labelMap[this.activeTab]
        },

        activeSubTabInfo() {
            return this.activeSubTab ? this.activeTabInfo[this.activeSubTab] : {}
        },

        knowledgeSpread() {
            return this.$store.state.global.knowledgeSpread
        },

        /**
         * 是否展现标签模块
         */
        showLabelInfo() {
            return Boolean(this.activeSubTab && this.knowledgeSpread[this.activeSubTab] && this.knowledgeSpread[this.activeSubTab].items && this.knowledgeSpread[this.activeSubTab].items.length > 0)
        }
    },

    created() {
        if (!this.showLabelInfo) {
            this.getV4List()
        }
        if(this.$route.name === 'index'){
            if(this.$store.state.global.config.navigators[this.$route.name].ball){
                this.ballOn = this.$store.state.global.config.navigators[this.$route.name].ball
            }
            if(sessionStorage.ballStatus === 'false'){
                this.ballOn.on = false
            }
        }
       
    },

    methods: {

        /**
         * 请求列表
         */
        getV4List() {

            // #region 正在加载或者无更多内容则不继续请求
            if (this.busy || !this.more) {
                return
            }
            this.busy = true
            // #endregion
            
            requestV4MixedList({
                limit: this.num,
                start: this.V4List.length,
                tagids: this.activeSubTab ? this.activeSubTab : this.activeTab
            }).then((result) => {
                const { data = {} } = result
                if (data.status == 0) {
                    let list = data.data && data.data.items ? data.data.items : []
                    this.V4List = this.V4List.concat(list)
                    this.more = Boolean(list.length >= this.num)
                } else {
                    this.more = false
                    if (this.V4List.length == 0) {
                        this.$toast('暂无内容')
                    }
                }
                this.busy = false

                /* #region 首屏加载完成时间上报 */
                if (!sessionStorage.igPerformance && history.length < 2 && performance && performance.timing) {
                    this.$nextTick(() => {
                        const { timing } = performance
                        window.aegisReport.reportTime('whiteScreen',  Date.now() - timing.fetchStart )
                        reportPerformanceData({
                            speedparams: `flag1=22259&flag2=1&flag3=1&11=${ Date.now() - timing.fetchStart }`
                        })
                        sessionStorage.igPerformance = 1
                    })
                }
                /* #endregion */
            })
        },

        /**
         * 广告跳转
         * @param {String} url - 广告 url 
         */
        toAd(url) {
            location.assign(url.includes('?') ? url + sessionStorage.tokenParams.replace('?', '&') : url + sessionStorage.tokenParams)
        },

        /**
         * 切换 tab
         * @param {Object} tab - 一级 tab
         */
        switchTab(tab) {
            let query = {
                tab: tab.id
            }
            this.activeTab = tab.id
            if (tab.label && tab.label.length > 0) {
                this.activeSubTab = tab.label[0].id
                query.subtab = tab.label[0].id
            } else {
                this.activeSubTab = ''
            }
            this.$router.replace({
                query
            })
        },

        /**
         * 切换二级 tab
         * @param {Object} tab - 二级 tab
         */
        switchSubTab(tab) {
            this.activeSubTab = tab.id
            this.$router.replace({
                query: Object.assign({}, this.$route.query, {
                    subtab: tab.id
                })
            })
        },

        touchstartEvent(event) {
            if (this.activeTabInfo.label.length <= 1) {
                return
            }
            const touch = event.targetTouches[0]
            this.originX = touch.clientX
            this.originY = touch.clientY
            this.originTime = Date.now()
        },

        touchendEvent(event) {
            if (this.activeTabInfo.label.length <= 1) {
                return
            }
            const touch = event.changedTouches[0]
            const offsetX = touch.clientX - this.originX
            const offsetY = touch.clientY - this.originY
            if (Math.abs(offsetX) > Math.abs(offsetY)) {
                return
            } else {
                const rate = Math.abs(offsetY / (Date.now() - this.originTime))

                // 下拉
                if (offsetY > 0 && rate > 0.6) {
                    this.translate = false
                    this.timer = setTimeout(() => {
                        this.spread = false
                    }, 300)
                }

                // 上拉
                if (offsetY < 0 && rate > 0.1) {
                    clearTimeout(this.timer)
                    this.translate = true
                    this.spread = true
                }
            }
        }
    }
}
</script>

<style lang="postcss">
.ig-index {
    .ig-background--tabs,
    .ig--subtab {
        transition: opacity 0.3s ease-in-out;
    }
    .ig-background--tabs.ig--hidden,
    .ig--subtab.ig--hidden {
        opacity: 0;
    }
    .ig--scroll {
        flex: auto;
        padding-right: 20px;
        padding-left: 20px;
        @media (orientation: landscape) {
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            .ig--item:nth-child(2n) {
                @media (orientation: landscape) {
                    margin-left: 20px;
                }
            }
        }
        @media (min-aspect-ratio: 2/1) {
            padding-right: var(--safe-area-inset-right);
        }
        .sui-load {
            flex: none;
            width: 100%;
        }
    }
    .ig--label {
        margin-top: 20px;
        transform: translate3d(0, 0, 0);
        transition: transform 0.3s ease-in-out;
    }
    .ig--label.ig--offset {
        transform: translate3d(0, -235px, 0);
    }
    .ig--label.ig--height {
        position: absolute;
        left: 0;
        top: 235px;
        z-index: 1;
        width: 100%;
        height: 100%;
        margin-top: 0;
    }
}
</style>